import React from "react";

export type PressLink = {
  id: string;
  url: string;
  label?: string;
};

type LinkKind = "youtube" | "vimeo" | "video" | "link";

function detectKind(url: string): { kind: LinkKind; embedUrl?: string } {
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.replace(/^www\./, "");

    if (host === "youtube.com" || host === "m.youtube.com") {
      const v = parsed.searchParams.get("v");
      if (v) return { kind: "youtube", embedUrl: `https://www.youtube.com/embed/${v}` };
      const shorts = parsed.pathname.match(/^\/shorts\/([^/]+)/);
      if (shorts) return { kind: "youtube", embedUrl: `https://www.youtube.com/embed/${shorts[1]}` };
      const embed = parsed.pathname.match(/^\/embed\/([^/]+)/);
      if (embed) return { kind: "youtube", embedUrl: url };
    }
    if (host === "youtu.be") {
      const id = parsed.pathname.slice(1);
      if (id) return { kind: "youtube", embedUrl: `https://www.youtube.com/embed/${id}` };
    }

    if (host === "vimeo.com") {
      const match = parsed.pathname.match(/\/(\d+)/);
      if (match) return { kind: "vimeo", embedUrl: `https://player.vimeo.com/video/${match[1]}` };
    }

    if (/\.(mp4|webm|ogg|mov)$/i.test(parsed.pathname)) {
      return { kind: "video" };
    }
  } catch {
    // not a valid absolute URL — fall through to generic link
  }
  return { kind: "link" };
}

export function PressMediaLink({ link }: { link: PressLink }) {
  const { kind, embedUrl } = detectKind(link.url);

  if (kind === "youtube" || kind === "vimeo") {
    return (
      <div className="press-video-wrapper">
        <iframe
          src={embedUrl}
          title={link.label || "Video"}
          allowFullScreen
          frameBorder="0"
        />
      </div>
    );
  }

  if (kind === "video") {
    return (
      <video className="press-video-native" controls src={link.url}>
        Browserul tău nu suportă redarea video.
      </video>
    );
  }

  return (
    <a className="press-link-button" href={link.url} target="_blank" rel="noreferrer">
      {link.label || link.url}
    </a>
  );
}
